import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { painPoints } from '../data/salesData';
export function ProblemSection() {
  return <section className="border-b border-[var(--line)] bg-[var(--bg-alt)] py-16 sm:py-20" data-id="element-199" data-mp="30gxu3xcr9fmr">
      <div className="mx-auto max-w-4xl px-4" data-id="element-200" data-mp="2vqhgac50vrzv">
        <SectionHeading data-id="element-201" data-mp="2vppkp1bfdu9l">
          ¿Qué pasa cuando llega un alumno con hernia, embarazo o postparto?
        </SectionHeading>

        <div className="mx-auto mt-8 max-w-2xl space-y-4 text-[var(--text)]/80" data-id="element-202" data-mp="39jyztwxpl4pw">
          <p data-id="element-203" data-mp="35fr77oo4r4me">
            Sos instructor de Pilates certificado. Sabés dar clase. Pero cuando
            alguien llega con un diagnóstico en la mano, el problema no es tu
            formación: es no tener un protocolo escrito para decidir qué adaptar,
            qué documentar y cuánto cobrar.
          </p>
          <p className="text-lg font-semibold text-[var(--rose)]" data-id="element-204" data-mp="1p2aua8tsktk1">
            No es falta de vocación. Es falta de un sistema.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3 sm:grid-cols-2" data-id="element-205" data-mp="jdwmx3wkbyzj">
          {painPoints.map(point => <li key={point} className="flex items-start gap-3 rounded-xl border border-[var(--danger)]/25 bg-[var(--danger)]/[0.07] p-4" data-id="element-206" data-mp="oczr6m4py16g">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[var(--danger)]/20" data-id="element-207" data-mp="x4rxqlqmgq5r">
                <XIcon className="h-4 w-4 text-[var(--danger)]" aria-hidden="true" data-id="element-208" data-mp="12337yxktx2oi" />
              </span>
              <span className="text-[var(--text)]/90" data-id="element-209" data-mp="1714r1ii991zz">{point}</span>
            </li>)}
        </ul>

        <p className="mt-10 text-center font-serif-display text-2xl font-semibold text-[var(--text)] sm:text-3xl" data-id="element-210" data-mp="1c2k9r3wymwf7">
          ¿Y si el próximo alumno limitado fuera tu mejor alumno del año?
        </p>
      </div>
    </section>;
}